import React, { CSSProperties } from 'react';
import styles from './SpecialInstruction.module.scss';
import { useTranslation } from '../../hooks/useTranslation';

interface ISpecialInstructionProps {
	externalStyle: CSSProperties;
	label?: string;
	placeholder?: string;
	text?: string;
	handleChange: (value: string) => void;
}

const MAX_TEXT_ALLOWED = 33;

const SpecialInstruction: React.FC<ISpecialInstructionProps> = ({
	externalStyle,
	label,
	placeholder,
	text,
	handleChange,
	...props
}: ISpecialInstructionProps) => {
	const { t } = useTranslation();

	return (
		<>
			<section className={styles.specialInstruction} {...props} style={externalStyle} id="specialInstruction">
				<div>
					<div className={styles.specialInstructionContainer}>
						<div className={styles.labelGroup}>
							<label className={styles.instructionLabel}>{label}</label>
							<label htmlFor="specialInstructions" className={styles.instructionLabel2}>
								{t('component:specialInstruction:hint:text')}
							</label>
						</div>
						<div className={styles.modifierOptional}>{t('component:modifier:optional:label')}</div>
					</div>
					<input
						className={styles.instructionTextarea}
						placeholder={placeholder}
						maxLength={MAX_TEXT_ALLOWED}
						onChange={(e) => handleChange(e.target.value)}
						value={text}
					/>
				</div>
			</section>
		</>
	);
};

export default SpecialInstruction;
